export default "__VITE_ASSET__BV50a6sR__"